import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useUser } from "../contexts/UserContext";
import { buildOAuthProfileState, isOAuthUser, readOAuthSignupContext } from "../utils/oauthSignup";

/**
 * Quem entrou pelo Google e fechou a aba antes do telefone tem sessão, mas não
 * tem perfil. Qualquer rota protegida manda de volta para terminar o cadastro.
 * Só age quando a API confirmou que o perfil não existe (profileMissing).
 */
export default function OAuthSignupGuard({ children }) {
  const { user } = useAuth();
  const { profileMissing, loading } = useUser();

  if (!loading && profileMissing && isOAuthUser(user)) {
    return (
      <Navigate
        to="/register-profile"
        replace
        state={buildOAuthProfileState(user, readOAuthSignupContext())}
      />
    );
  }
  return children;
}
